<template>
  <div v-if="visible" class="overlay" @click.self="close">
    <div class="modal-box">
      <div class="modal-head">
        <h3 class="modal-title">{{ form.id ? 'Aksiyani tahrirlash' : 'Yangi aksiya' }}</h3>
        <button class="close-btn" @click="close">&times;</button>
      </div>

      <div class="modal-body">
        <!-- Banner rasm -->
        <div class="image-uploader" @click="$refs.fileInput.click()">
          <img v-if="previewUrl" :src="previewUrl" alt="banner" />
          <div v-else class="image-placeholder">
            🖼️ <div>Banner rasm tanlang</div>
          </div>
          <input ref="fileInput" type="file" accept="image/*" hidden @change="onFileChange" />
        </div>

        <div class="field-group">
          <label class="flabel">Aksiya nomi</label>
          <input v-model="form.name" type="text" class="finput" placeholder="Yangi yil aksiyasi" @keyup.enter="save" />
        </div>

        <div class="field-group">
          <label class="flabel">Tavsif (ixtiyoriy)</label>
          <textarea v-model="form.description" class="finput finput-textarea" rows="2" placeholder="Aksiya haqida..."></textarea>
        </div>

        <div class="field-row-2">
          <div class="field-group">
            <label class="flabel">Boshlanish sanasi</label>
            <input v-model="startDateStr" type="date" class="finput" />
          </div>
          <div class="field-group">
            <label class="flabel">Tugash sanasi</label>
            <input v-model="endDateStr" type="date" class="finput" />
          </div>
        </div>

        <div class="field-group">
          <label class="active-toggle">
            <input type="checkbox" v-model="form.is_active" />
            <span>Aksiya faol</span>
          </label>
        </div>
      </div>

      <div class="modal-foot">
        <button class="btn-cancel-m" @click="close">Bekor</button>
        <button class="btn-save-m" @click="save" :disabled="loading">
          {{ loading ? 'Saqlanmoqda...' : 'Saqlash' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

const dateToUnix = (s) => s ? Math.floor(new Date(s).getTime() / 1000) : null;
const unixToDate = (t) => t ? new Date(Number(t) * 1000).toISOString().slice(0, 10) : '';

export default {
  name: 'AksiyaForm',
  props: {
    value: { type: Boolean, default: false },
    editItem: { type: Object, default: null },
  },
  data() {
    return {
      loading: false,
      form: { id: null, name: '', description: '', image: null, is_active: true, start_date: null, end_date: null },
      file: null,
      previewUrl: '',
      startDateStr: '',
      endDateStr: '',
    };
  },
  computed: {
    visible: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); },
    },
  },
  watch: {
    value(v) { if (v) this.loadFromProp(); },
  },
  methods: {
    loadFromProp() {
      if (this.editItem && this.editItem.id) {
        this.form = {
          id:          this.editItem.id,
          name:        this.editItem.name || '',
          description: this.editItem.description || '',
          image:       this.editItem.image || null,
          is_active:   !!this.editItem.is_active,
          start_date:  this.editItem.start_date,
          end_date:    this.editItem.end_date,
        };
        this.startDateStr = unixToDate(this.editItem.start_date);
        this.endDateStr   = unixToDate(this.editItem.end_date);
        this.previewUrl   = this.editItem.image || '';
      } else {
        this.form = { id: null, name: '', description: '', image: null, is_active: true, start_date: null, end_date: null };
        this.startDateStr = '';
        this.endDateStr   = '';
        this.previewUrl   = '';
      }
      this.file = null;
    },
    close() { this.visible = false; },

    onFileChange(e) {
      const f = e.target.files[0];
      if (!f) return;
      this.file = f;
      this.previewUrl = URL.createObjectURL(f);
    },

    async save() {
      if (!this.form.name.trim()) return alert('Aksiya nomini kiriting!');
      this.loading = true;
      try {
        const fd = new FormData();
        fd.append('name', this.form.name.trim());
        if (this.form.description) fd.append('description', this.form.description);
        fd.append('is_active', this.form.is_active ? 'true' : 'false');
        if (this.startDateStr) fd.append('start_date', dateToUnix(this.startDateStr));
        if (this.endDateStr)   fd.append('end_date',   dateToUnix(this.endDateStr));
        if (this.file) fd.append('image', this.file);

        if (this.form.id) {
          await axios.patch(`/api/v1/aksiya/${this.form.id}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        } else {
          await axios.post('/api/v1/aksiya', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        }
        this.$emit('saved');
        this.close();
      } catch (e) {
        alert('Xatolik: ' + (e.response?.data?.message || e.message));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed; inset: 0;
  background: rgba(15, 23, 42, 0.45);
  z-index: 9999;
  display: flex; align-items: center; justify-content: center;
  backdrop-filter: blur(3px);
}
.modal-box {
  background: white; border-radius: 24px;
  width: 480px; max-width: 95vw;
  box-shadow: 0 24px 64px rgba(0,0,0,0.18);
  display: flex; flex-direction: column;
  max-height: 92vh; overflow: hidden;
}
.modal-head {
  padding: 22px 24px 16px;
  border-bottom: 1px solid #f1f5f9;
  display: flex; justify-content: space-between; align-items: center;
}
.modal-title { margin: 0; font-size: 18px; font-weight: 800; color: #1e293b; }
.close-btn {
  background: #f1f5f9; border: none;
  width: 34px; height: 34px; border-radius: 50%;
  font-size: 22px; cursor: pointer; color: #64748b;
  display: flex; align-items: center; justify-content: center;
}
.modal-body {
  padding: 20px 24px;
  overflow-y: auto;
  display: flex; flex-direction: column; gap: 14px;
}
.modal-foot {
  padding: 16px 24px;
  border-top: 1px solid #f1f5f9;
  display: flex; gap: 10px;
}

.image-uploader {
  height: 160px;
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 14px;
  cursor: pointer;
  overflow: hidden;
  display: flex; align-items: center; justify-content: center;
  transition: 0.15s;
}
.image-uploader:hover { border-color: #5850ec; background: #f5f3ff; }
.image-uploader img { width: 100%; height: 100%; object-fit: cover; }
.image-placeholder {
  text-align: center; color: #94a3b8;
  font-size: 14px; font-weight: 600;
  display: flex; flex-direction: column; gap: 6px;
}
.image-placeholder div { font-size: 32px; }

.field-group { display: flex; flex-direction: column; gap: 6px; }
.field-row-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.flabel { font-size: 12px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.3px; }
.finput {
  height: 44px;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 0 14px;
  font-size: 14px; font-weight: 600; color: #1e293b;
  outline: none; transition: 0.2s;
  width: 100%; box-sizing: border-box;
}
.finput:focus { border-color: #5850ec; box-shadow: 0 0 0 3px rgba(88,80,236,0.1); }
.finput-textarea { height: auto; padding: 12px 14px; resize: vertical; min-height: 60px; }

.active-toggle { display: flex; align-items: center; gap: 8px; cursor: pointer; user-select: none; }
.active-toggle input { width: 18px; height: 18px; cursor: pointer; }
.active-toggle span { font-weight: 700; color: #475569; }

.btn-cancel-m {
  flex: 1; height: 46px;
  background: #f1f5f9; color: #64748b;
  border: none; border-radius: 14px;
  font-weight: 700; cursor: pointer;
}
.btn-save-m {
  flex: 2; height: 46px;
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white; border: none; border-radius: 14px;
  font-weight: 800; cursor: pointer;
  transition: 0.2s;
}
.btn-save-m:disabled { opacity: 0.6; }
</style>
